import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import BasePage from '../../BasePage';
import { RegisterSection } from '../../components';

export default class Register extends BasePage {
  render() {
    return (
      <>
        <Container>
          <Row className="justify-content-center">
            <Col md="4">
              <RegisterSection page={this} withLogo={true} />
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}
